<template>
  <div class="shouye-center-c">
    <div class="sy-c-top">
        <h2>News Center</h2>
        <div class="sy-c-top-box">
            <span>新闻中心</span>
        </div>
    </div>
    <div class="sy-c-center">
        <div class="center">
            <div class="sy-c-center-L" v-if="newsCenter && newsCenter.headline">
                    <h5>新闻头条</h5>
                <div class="sy-c-center-L-img">
                    <a :href="'/detail?id='+newsCenter.headline.id"> <img :src="newsCenter.headline.headlineImage" /></a>
                </div>
                <div class="sy-c-center-L-title">
                    <a :href="'/detail?id='+newsCenter.headline.id">
                        <h4>{{newsCenter.headline.title}}</h4></a>
                    <a :href="'/detail?id='+newsCenter.headline.id">
                        <p>{{newsCenter.headline.headlineDescribe}}</p>
                    </a>
                </div>
                                            </div>
            <div class="sy-c-center-R" v-if="newsCenter && newsCenter.realtime">
                <h5>即时资讯</h5>                                
                 <div class="sy-c-center-R-bianli" v-for="(news,i) in newsCenter.realtime" :key="i">
                    <p>{{news.publishTime}}</p>
                    <div class="sy-c-center-R-box">
                        <a :href="'/detail?id='+news.id"><img :src="news.realtimeImage" /></a>
                        <div class="sy-c-center-R-box-text">
                            <h6><a :href="'/detail?id='+news.id">{{news.title}}</a></h6>
                            <a :href="'/detail?id='+news.id">
                                <p>{{news.realtimeDescribe}}</p>
                            </a>
                        </div>
                    </div>
                </div>          
            </div>
        </div>
    </div>
    <div class="sy-footer">
        <div class="sy-footer-img">
            <a @click="goNews">
                <img src="@s/skin/web/img/index/chakan.png" />
            </a>
        </div>

        <div class="sy-footer-img-se">
            <a @click="goNews">
                <img src="@s/skin/web/img/index/genduobianse.png" />
            </a>
        </div>
    </div>
</div>
</template>

<script>
export default {
  name: "C",
  data() {
    return {
        newsCenter: this.$store.state.newsCenter
    };
  },
  watch:{
    '$store.state.newsCenter'(val){
        this.newsCenter = val
    }
  },
  methods:{
    goNews(){
        this.$router.push({
            name:'news',
            params:{
               tab: 1
            }
        })
    }
  },
  mounted(){
    
  }
}
</script>
